import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface CorrectiveActionTypesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<CorrectiveActionTypesServiceData>(
    db,
    'correctiveActionTypesService'
  );

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
